<template>
  <div class="relative flex flex-col justify-between min-h-94 mr-20 cursor-pointer bg-primary
               anim-all rounded-8 p-14 h-full min-w-280 max-w-280 w-full m-1 mb-20"
       :class="isDarkMode ? 'border-2 border-grey-500 hover:border-grey-300' : 'shadow-event hover:shadow-event-hover'"
  >
    <div class="flex items-end mb-5">
      <p class="font-extrabold text-18 leading-none mr-5">{{ computedDate.date }}</p>
      <p class="text-12 leading-none opacity-50 font-medium mb-1 mr-5">{{ computedDate.name }}</p>
      <p class="text-12 leading-none opacity-50 font-medium mb-1">{{ computedDate.year }}</p>
    </div>
    <div>
      <div class="font-Inter mb-4 text-15 leading-small font-semibold pr-25 line-clamp-2">
        {{ event.event.title }}
      </div>

      <p class="text-14 mb-7 leading-normal line-clamp-3" :class="isDarkMode ? 'text-grey-250' : 'text-grey-1000'">
        {{ event.event.subTitle }}
      </p>

      <div class="text-14 mt-5 flex items-center" @click.stop>
        <router-link v-if="event.event.project" class="text-brand" :to="url">@{{ event.event.project.title }}</router-link>
        <p class="flex items-center opacity-50 ml-auto">
          <i class="icon-folder-open -mr-5 pr-10 text-16" />
          {{ bookTitle }}
        </p>
      </div>
    </div>

    <div class="flex justify-between items-center mt-10 text-14">
      <div class="font-bold">
        <p v-if="time">{{ time }}</p>
        <div v-else>All Day</div>
      </div>

      <div class="flex items-center">
        <div v-if="hasTags" class="flex -mr-5 text-dark-600">
          <div
            v-for="tag in event.event.eventTags"
            :key="tag.id"
            class="text-11 font-medium flex items-center flex-shrink-0 rounded-8 h-23 min-w-50 px-7 mr-5 lowercase"
            :style="`background-color: #${(tag.color).toString(16)}`"
          >
            <p v-if="!!tag.name" class="text-12">#</p>
            {{ tag.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    event: Object
  },

  setup (props) {
    const { state, getters } = useStore()

    const isTeamAccount = computed(() => getters.isTeamAccount)
    const isDarkMode = computed(() => getters.isDarkMode)
    const team = computed(() => state.team.team)

    const books = computed(() => state.book.books.filter(b => !b.isSection))
    const selectedBook = computed(() => books.value.find(b => b.id === props.event.bookId))
    const bookTitle = computed(() => selectedBook.value.title.length > 13 ? `${selectedBook.value.title.slice(0, 13)}...` : selectedBook.value.title)

    const computedDate = computed(() => {
      const day = new Date(props.event.showAt).toLocaleString('en-US', { day: '2-digit' })
      const name = new Date(props.event.showAt).toLocaleString('en-US', { weekday: 'long' })
      const month = new Date(props.event.showAt).toLocaleString('en-US', { month: '2-digit' })
      const year = new Date(props.event.showAt).toLocaleString('en-US', { year: 'numeric' })

      return {
        date: `${day}.${month}`,
        name,
        year
      }
    })

    const hasTags = computed(() => props.event?.event?.eventTags?.length > 0)

    const time = computed(() => {
      const timeStart = props.event.event.timeStart?.substring(0, 5)
      const timeEnd = props.event.event.timeEnd?.substring(0, 5)

      return timeEnd ? `${timeStart}-${timeEnd}` : timeStart || null
    })

    const url = computed(() => {
      const path = isTeamAccount.value ? `/${team.value.link}` : ''

      return `${path}/space/${props.event.event.project.bookId}?page=${props.event.event.project.id}`
    })

    const events = computed(() => state.planner.upcomingEvents)

    return {
      url,
      time,
      events,
      hasTags,
      isDarkMode,
      computedDate,
      bookTitle
    }
  }
})
</script>
